<template>
  <div v-show="showLock">
    <div :class="pageData.template === 0 ? 'interview-table-wrap' :
    'interview-table-wrap isxiuman'">
      <div class="makeimg-wrap">
        <img class="logo-img" src="../../assets/interview/images/icon-logo-sh1.png" alt="">
        <table class="ms-table" width="1000" border="0" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <td colspan="3" class="fz16">
                <span v-if="pageData.interview_time">面试时间：{{ pageData.interview_time }}</span>
              </td>
              <td colspan="5" class="fz16">
                开学期：{{ pageData.custom_year }}年{{ pageData.custom_month }}月
              </td>
              <td colspan="2" class="fz16">
                <strong v-if="pageData.payment_cycle" style="color:red;">需要半年付费</strong>
              </td>
            </tr>
            <tr>
              <td colspan="10" align="center" class="bg-code fz20">面试调查表</td>
            </tr>
            <tr>
              <td colspan="10" align="center" class="bg-code fz16">申请人本人情况</td>
            </tr>
            <tr>
              <td class="bg-code">姓名</td>
              <td colspan="2">
                <input :value="pageData.name" type="text">
              </td>
              <td class="bg-code">姓名拼音</td>
              <td><input :value="pageData.name_pinyin" type="text"></td>
              <td class="bg-code">年龄</td>
              <td><input :value="pageData.age" type="text"></td>
              <td class="bg-code">性别</td>
              <td colspan="2">
                <select v-model="pageData.sex">
                  <option :value="1">男</option>
                  <option :value="2">女</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="bg-code">出生日期</td>
              <td colspan="2"><input :value="pageData.brithday" type="date"></td>
              <td class="bg-code">婚姻状况</td>
              <td>
                <select v-model="pageData.married">
                  <option :value="0">未婚</option>
                  <option :value="1">已婚</option>
                  <option :value="2">离异</option>
                </select>
              </td>
              <td class="bg-code">户籍所在地</td>
              <td colspan="2">
                <select v-model="pageData.custom_place_area">
                  <option value="0">0</option>
                  <option v-for="item in dictList.provinces" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </td>
              <td colspan="2">
                <select v-model="pageData.custom_place_city">
                  <option value="0">0</option>
                  <option v-for="item in cityList" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="bg-code">现住址</td>
              <td colspan="1">
                <select v-model="pageData.now_place_area">
                  <option value="0">0</option>
                  <option v-for="item in dictList.provinces" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </td>
              <td colspan="1">
                <select v-model="pageData.now_place_city">
                  <option value="0">0</option>
                  <option v-for="item in cityList3" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </td>
              <td colspan="4">
                <input :value="pageData.now_place" type="text">
              </td>
              <td class="bg-code">护照</td>
              <td colspan="2">
                <select v-model="pageData.has_passport">
                  <option :value="2">申请中</option>
                  <option :value="1">有</option>
                  <option :value="0">无</option>
                </select>
              </td>
            </tr>
            <tr v-if="btnLock">
              <td class="bg-code">家庭电话</td>
              <td colspan="2"><input :value="pageData.home_telephone" type="text" placeholder=""></td>
              <td class="bg-code">手机</td>
              <td><input :value="pageData.mobile" type="text"></td>
              <td class="bg-code">QQ</td>
              <td><input :value="pageData.qq" type="text"></td>
              <td class="bg-code">微信</td>
              <td colspan="2"><input :value="pageData.wechat" type="text"></td>
            </tr>
            <tr>
              <td class="bg-code">学历</td>
              <td colspan="2">
                <select v-model="pageData.final_edu">
                  <option value="0"></option>
                  <option v-for="(item, index) in dictList.education" :key="`edu_${index}`" :value="item.dic_key">{{ item.dic_value }}</option>
                </select>
              </td>
              <td colspan="2">
                <input type="text" :value="pageData.final_school_other">
              </td>
              <td class="bg-code">专业</td>
              <td><input :value="pageData.final_subject" type="text"></td>
              <td class="bg-code">日语专业</td>
              <td>
                <select v-model="pageData.japanese_major">
                  <option :value="1">是</option>
                  <option :value="0">否</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="bg-code" :rowspan="pageData.education_experience && pageData.education_experience.length + 1">教育经历</td>
              <td class="bg-code" colspan="3">学校名称（学历请从小学开始填写）</td>
              <td class="bg-code" colspan="3">入学时间</td>
              <td class="bg-code" colspan="3">毕业时间</td>
            </tr>
            <tr v-for="(item, index) in pageData.education_experience" :data-idx="index" :key="`eduexp_${index}`">
              <td colspan="3"><input :value="item.sh_name" type="text"></td>
              <td colspan="3">
                <table class="special-table2" width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td><input :value="item.start_time && item.start_time.substring(0,4)" type="text"></td>
                      <td class="bg-code">年</td>
                      <td><input :value="item.start_time && item.start_time.substring(5,7)" type="text"></td>
                      <td class="bg-code">月</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td colspan="3">
                <table class="special-table2" width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td><input :value="item.end_time && item.end_time.substring(0,4)" type="text"></td>
                      <td class="bg-code">年</td>
                      <td><input :value="item.end_time && item.end_time.substring(5,7)" type="text"></td>
                      <td class="bg-code">月</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="10" class="bordernone">
                <table class="special-table" border="0" cellspacing="0" cellpadding="0">
                  <tr>
                    <td class="bg-code">高考</td>
                    <td>
                      <select v-model="pageData.gaokao" style="min-width: 75px !important;">
                        <option :value="1">文科</option>
                        <option :value="2">理科</option>
                      </select>
                    </td>
                    <td>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td class="bg-code" style="min-width: 76px !important;">分数</td>
                            <td style="min-width: 76px !important;"><input :value="pageData.gaokao_score" type="text" v-if="pageData.gaokao"></td>
                            <td class="bg-code" style="min-width: 75px !important;">分</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td class="bg-code">艺考</td>
                    <td>
                      <select v-model="pageData.is_art_exam">
                        <option :value="0">未参加</option>
                        <option :value="1">参加过</option>
                      </select>
                    </td>
                    <td>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td class="bg-code">分数</td>
                            <td><input :value="pageData.art_exam_score" type="text" v-if="pageData.is_art_exam"></td>
                            <td class="bg-code">分</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td class="bg-code">会考</td>
                    <td>
                      <select v-model="pageData.general_exam">
                        <option :value="1">文科</option>
                        <option :value="2">理科</option>
                      </select>
                    </td>
                    <td>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td class="bg-code">分数</td>
                            <td><input :value="pageData.general_exam_score" type="text" v-if="pageData.general_exam"></td>
                            <td class="bg-code">分</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="bg-code" :rowspan="pageData.japanese_experience && pageData.japanese_experience.length + 1">日语学习经历</td>
              <td class="bg-code" colspan="3">学校名称</td>
              <td class="bg-code" colspan="3">入学时间</td>
              <td class="bg-code" colspan="3">毕业时间</td>
            </tr>
            <tr v-for="(item, index) in pageData.japanese_experience" :data-idx="index" :key="`jpstudy_${index}`">
              <td colspan="3"><input :value="item.name" type="text"></td>
              <td colspan="3">
                <table class="special-table2" width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td><input :value="item.starttime && item.starttime.substring(0,4)" type="text"></td>
                      <td class="bg-code">年</td>
                      <td><input :value="item.starttime && item.starttime.substring(5,7)" type="text"></td>
                      <td class="bg-code">月</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td colspan="3">
                <table class="special-table2" width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td><input :value="item.endtime && item.endtime.substring(0,4)" type="text"></td>
                      <td class="bg-code">年</td>
                      <td><input :value="item.endtime && item.endtime.substring(5,7)" type="text"></td>
                      <td class="bg-code">月</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td :rowspan="pageData.japanese_exam && pageData.japanese_exam.length + 1" class="bg-code">日语考试</td>
              <td colspan="2" class="bg-code">考试名称</td>
              <td class="bg-code">参加状态</td>
              <td colspan="3" class="bg-code">考试时间&等级</td>
              <td colspan="3" class="bg-code">分数</td>
            </tr>
            <tr v-for="(item, index) in pageData.japanese_exam" :data-idx="index" :key="`exam_${index}`">
              <td :colspan="item.etype === 'other' ? 1 : 2">{{ item.etype !== 'other' ? item.name : '其他' }}</td>
              <td v-if="item.etype === 'other'">
                <input type="text" :value="item.othername">
              </td>
              <td>
                <select v-model="item.exam_status">
                  <option value="0">计划报名</option>
                  <option value="1">已报名</option>
                  <option value="2">已合格</option>
                  <option value="3">未合格</option>
                </select>
              </td>
              <td colspan="3">
                <table class="special-table2" width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td><input :value="item.time && item.time.substring(0,4)" type="text"></td>
                      <td class="bg-code">年</td>
                      <td><input :value="item.time && item.time.substring(5,7)" type="text"></td>
                      <td class="bg-code">月</td>
                      <td>
                        <input type="text" :value="item.etype !== 'other' && item.etype !== 0 ? (dictList[`exam_${item.etype}`] && dictList[`exam_${item.etype}`][item.exam_level] ? dictList[`exam_${item.etype}`][item.exam_level] : item.otherlevel) : item.otherlevel">
                      </td>
                      <td class="bg-code">级</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td class="bg-code">分数</td>
              <td colspan="2">
                <table class="special-table2" width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td><input :value="item.score" type="text"></td>
                      <td class="bg-code">分</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td class="bg-code" :rowspan="pageData.work_experience && pageData.work_experience.length + 1">职历</td>
              <td class="bg-code" colspan="3">公司名称</td>
              <td class="bg-code" colspan="3">工作时间</td>
              <td class="bg-code" colspan="3">离职时间</td>
            </tr>
            <tr v-for="(item, index) in pageData.work_experience" :data-idx="index" :key="`work_${index}`">
              <td colspan="3"><input :value="item.name" type="text"></td>
              <td colspan="3">
                <table class="special-table2" width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td><input :value="item.starttime && item.starttime.substring(0,4)" type="text"></td>
                      <td class="bg-code">年</td>
                      <td><input :value="item.starttime && item.starttime.substring(5,7)" type="text"></td>
                      <td class="bg-code">月</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td colspan="3">
                <table class="special-table2" width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td><input :value="item.endtime && item.endtime.substring(0,4)" type="text"></td>
                      <td class="bg-code">年</td>
                      <td><input :value="item.endtime && item.endtime.substring(5,7)" type="text"></td>
                      <td class="bg-code">月</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="10" class="bordernone">
                <table class="special-table" width="100%" border="0" cellpadding="0" cellspacing="0">
                  <tr>
                    <td class="bg-code" :rowspan="pageData.japan_experience && pageData.japan_experience.length + 1">日本签证申请历史</td>
                    <td class="bg-code" colspan="2">签证类型</td>
                    <td class="bg-code">开始时间</td>
                    <td class="bg-code">结束时间</td>
                    <td class="bg-code" colspan="2">目的</td>
                    <td class="bg-code">是否拒签</td>
                    <td class="bg-code" colspan="2">拒签理由</td>
                  </tr>
                  <tr v-for="(item, index) in pageData.japan_experience" :data-idx="index" :key="`jpexp_${index}`">
                    <td colspan="2">
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td>
                              <select v-model="item.visatype">
                                <option value="0">无</option>
                                <option value="单次旅行">单次旅行</option>
                                <option value="多次往返旅行">多次往返旅行</option>
                                <option value="留学">留学</option>
                                <option value="研修（技能实习）">研修（技能实习）</option>
                                <option value="特定活动">特定活动</option>
                                <option value="就职">就职</option>
                                <option value="其他">其他</option>
                              </select>
                            </td>
                            <td v-if="item.visatype === '其他'">
                              <input :value="item.othertype" placeholder="" type="text">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td class="w60"><input :value="item.starttime && item.starttime.substring(0,4)" type="text"></td>
                            <td class="bg-code w30">年</td>
                            <td class="w50"><input :value="item.starttime && item.starttime.substring(5,7)" type="text"></td>
                            <td class="bg-code w30">月</td>
                            <td class="w50"><input :value="item.starttime && item.starttime.substring(8,11)" type="text"></td>
                            <td class="bg-code w30">日</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td class="w60"><input :value="item.endtime && item.endtime.substring(0,4)" type="text"></td>
                            <td class="bg-code w30">年</td>
                            <td class="w50"><input :value="item.endtime && item.endtime.substring(5,7)" type="text"></td>
                            <td class="bg-code w30">月</td>
                            <td class="w50"><input :value="item.endtime && item.endtime.substring(8,11)" type="text"></td>
                            <td class="bg-code w30">日</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td colspan="2">
                      <input :value="item.ends" type="text">
                    </td>
                    <td>
                      <select v-model="item.deny">
                        <option value="0">否</option>
                        <option value="1">是</option>
                      </select>
                    </td>
                    <td colspan="2">
                      <input :value="item.deny !== '1' ? '' : item.denytext" type="text">
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="10" align="center" class="bg-code fz16">家庭成员情况</td>
            </tr>
            <tr>
              <td class="bg-code">关系</td>
              <td class="bg-code">姓名</td>
              <td class="bg-code">年龄</td>
              <td class="bg-code" colspan="2">职业</td>
              <td class="bg-code" colspan="2">就职公司/就读学校</td>
              <td class="bg-code" colspan="2">联系电话</td>
            </tr>
            <tr v-for="(item, index) in pageData.family_member" :data-idx="index" :key="`family_${index}`">
              <td class="bg-code">{{ item.relation === '其他' ? item.othername : item.relation }}</td>
              <td><input :value="item.name" type="text"></td>
              <td><input :value="item.age" type="text"></td>
              <td colspan="2"><input :value="item.job" type="text"></td>
              <td colspan="2"><input :value="item.company" type="text"></td>
              <td colspan="2"><input v-if="btnLock" :value="item.phone" type="text"></td>
            </tr>
            <tr>
              <td colspan="10" align="center" class="bg-code fz16">在日亲属朋友情况</td>
            </tr>
            <tr>
              <td class="bg-code">关系</td>
              <td class="bg-code">姓名</td>
              <td class="bg-code">年龄</td>
              <td class="bg-code" colspan="2">职业</td>
              <td class="bg-code" colspan="2">就职公司/就读学校</td>
              <td class="bg-code" colspan="2">联系电话</td>
            </tr>
            <tr v-for="(item, index) in pageData.japan_relatives" :data-idx="index" :key="`jprelative_${index}`">
              <td class="bg-code">{{ item.relation === '其他' ? item.othername : item.relation }}</td>
              <td><input :value="item.name" type="text"></td>
              <td><input :value="item.age" type="text"></td>
              <td colspan="2"><input :value="item.job" type="text"></td>
              <td colspan="2"><input :value="item.company" type="text"></td>
              <td colspan="2"><input v-if="btnLock" :value="item.phone" type="text"></td>
            </tr>
            <tr>
              <td colspan="10" align="center" class="bg-code fz16">经费支付人情况</td>
            </tr>
            <tr>
              <td class="bg-code">关系</td>
              <td class="bg-code">姓名</td>
              <td class="bg-code">年龄</td>
              <td class="bg-code" colspan="2">职业</td>
              <td class="bg-code" colspan="2">就职公司/就读学校</td>
              <td class="bg-code" colspan="2">联系电话</td>
            </tr>
            <tr v-for="(item, index) in pageData.funding_payer" :data-idx="index" :key="`payer_${index}`">
              <td class="bg-code">{{ item.relation === '其他' ? item.othername : item.relation }}</td>
              <td><input :value="item.name" type="text"></td>
              <td><input :value="item.age" type="text"></td>
              <td colspan="2"><input :value="item.job" type="text"></td>
              <td colspan="2"><input :value="item.company" type="text"></td>
              <td colspan="2"><input v-if="btnLock" :value="item.phone" type="text"></td>
            </tr>
            <tr>
              <td class="bg-code">备注信息</td>
              <td colspan="9" class="jm-tal" style="padding: 0 10px; word-break: break-all">{{ pageData.remark }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btn-wrap">
        <!-- <el-button v-if="btnLock" @click="openEdit" type="primary">编辑</el-button> -->
        <el-button @click="makeImg" type="primary">保存为图片</el-button>
        <el-button @click="makeHiddenImg" type="warning">保存为数据脱敏图片</el-button>
        <el-button @click="exportExcel" type="success">导出为Excel</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/index.css';
import html2canvas from 'html2canvas';

export default {
  components: {

  },

  data() {
    return {
      crm_id: '',
      dictList: '',
      cityList: [],
      cityList3: [],
      showLock: false,
      pageData: {
        custom_year: 0,
        custom_month: 0,
        name: '',
        name_pinyin: '',
        age: '',
        sex: '1',
        brithday: '',
        married: '0',
        custom_place_area: 0,
        custom_place_city: 0,
        now_place: null,
        now_place_area: 0,
        now_place_city: 0,
        has_passport: '1',
        home_telephone: '',
        mobile: '',
        qq: '',
        wechat: '',
        education: 0,
        major: '',
        japanese_major: '0',
        education_experience: '',
        gaokao: '0',
        gaokao_score: '',
        art_exam: '0',
        art_exam_score: '',
        general_exam: '0',
        general_exam_score: '',
        japanese_experience: [],
        japanese_exam: [],
        work_experience: [],
        japan_experience: [],
        family_member: [],
        japan_relatives: [],
        funding_payer: [],
        remark: '',
        pay_half_year: ''
      },
    };
  },
  computed: {
    btnLock() {
      if (!this.$hasPermission([108], true)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    // 获取页面数据
    getPageData: function(crmid) {
      this.$http._post({
        url: '/interview/Form/interviewDict2020'
      }).then(({ data }) => {
        this.dictList = data;
        let msid = this.$route.query.msid;
        this.$http._post({
          url: '/interview/Form/readInterviewUse',
          data: { crm_id: crmid, msid: msid }
        }).then(({ data }) => {
          data.married = Number(data.married || 0);
          this.showLock = true;
          this.pageData = data;
          if (data.custom_place_city && data.custom_place_city !== '0') {
            this.dictList.cities[data.custom_place_area].forEach((item) => {
              if (parseInt(item.id, 0) === data.custom_place_city) {
                this.cityList = this.dictList.cities[data.custom_place_area];
                return false;
              }
            });
          }
          if (data.now_place_city && data.now_place_city !== '0') {
            this.dictList.cities[data.now_place_area].forEach((item) => {
              if (parseInt(item.id, 0) === data.now_place_city) {
                this.cityList3 = this.dictList.cities[data.now_place_area];
                return false;
              }
            });
          }
          if (!data.education_experience || data.education_experience.length < 1) {
            data.education_experience = [{ sh_name: '', start_time: '', end_time: '' }];
          }
          if (!data.japanese_experience || data.japanese_experience.length < 1) {
            data.japanese_experience = [{ name: '', starttime: '', endtime: '' }];
          }
          if (!data.work_experience || data.work_experience.length < 1) {
            data.work_experience = [{ name: '', starttime: '', endtime: '' }];
          }
          if (!data.japan_experience || data.japan_experience.length < 1) {
            data.japan_experience = [{
              starttime: '',
              endtime: '',
              visatype: '0',
              othertype: '',
              ends: '',
              deny: 0,
              denytext: ''
            }];
          }
          if (!data.family_member || data.family_member.length < 1) {
            data.family_member = [{
              name: '',
              relation: '',
              age: '',
              company: '',
              job: '',
              phone: '',
              othername: ''
            }];
          }
          if (!data.japan_relatives || data.japan_relatives.length < 1) {
            data.japan_relatives = [{
              name: '',
              relation: '',
              age: '',
              company: '',
              job: '',
              phone: '',
              othername: ''
            }];
          }
          if (!data.funding_payer || data.funding_payer.length < 1) {
            data.funding_payer = [{
              name: '',
              relation: '',
              age: '',
              company: '',
              job: '',
              phone: '',
              othername: ''
            }];
          }
          if (!data.japanese_exam || data.japanese_exam.length < 1) {
            data.japanese_exam = [{
              name: '',
              othername: '',
              exam_status: 3,
              score: '',
              etype: 0,
              time: '',
              exam_level: '0',
              otherlevel: ''
            }];
          }
        });
      });
    },
    // 生成图片
    makeImg: function() {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // 锁定报名表
      this.lockSignupTable();
      setTimeout(() => {
        html2canvas(document.querySelector('.makeimg-wrap')).then((canvas) => {
          let dataURL = canvas.toDataURL('image/png');
          let a = document.createElement('a');
          a.download = this.getReportName();
          // 设置图片地址
          a.href = dataURL;
          a.click();
        });
      }, 1000);
    },
    makeHiddenImg: function() {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // 锁定报名表
      this.lockSignupTable();
      // 暂存原值
      let tmpWechat = this.pageData.wechat;
      let tmpQQ = this.pageData.qq;
      let tmpMobile = this.pageData.mobile;
      let tmpHomeTelphone = this.pageData.home_telephone;
      this.pageData.wechat = this.pageData.wechat ? '******' : '';
      this.pageData.qq = this.pageData.qq ? '******' : '';
      this.pageData.mobile = this.pageData.mobile ? '******' : '';
      this.pageData.home_telephone = this.pageData.home_telephone ? '******' : '';
      // 家庭成员、朋友、支付人电话转******
      let familyMems = this.pageData.family_member;
      let japanRelatives = this.pageData.japan_relatives;
      let fundingPayer = this.pageData.funding_payer;
      let familyMemsPhonesTemp = [];
      let japanRelativesPhonesTemp = [];
      let fundingPayerPhonesTemp = [];
      if (familyMems.length > 0) {
        for (let i = 0; i < familyMems.length; i++) {
          familyMemsPhonesTemp.push(familyMems[i].phone);
          familyMems[i].phone = familyMems[i].phone ? '******' : '';
        }
      }
      if (japanRelatives.length > 0) {
        for (let i = 0; i < japanRelatives.length; i++) {
          japanRelativesPhonesTemp.push(japanRelatives[i].phone);
          japanRelatives[i].phone = japanRelatives[i].phone ? '******' : '';
        }
      }
      if (fundingPayer.length > 0) {
        for (let i = 0; i < fundingPayer.length; i++) {
          fundingPayerPhonesTemp.push(fundingPayer[i].phone);
          fundingPayer[i].phone = fundingPayer[i].phone ? '******' : '';
        }
      }
      setTimeout(() => {
        html2canvas(document.querySelector('.makeimg-wrap')).then((canvas) => {
          let dataURL = canvas.toDataURL('image/png');
          let a = document.createElement('a');
          a.download = this.getReportName();
          // 设置图片地址
          a.href = dataURL;
          a.click();
          // 恢复原值
          this.pageData.wechat = tmpWechat;
          this.pageData.qq = tmpQQ;
          this.pageData.mobile = tmpMobile;
          this.pageData.home_telephone = tmpHomeTelphone;
          // 家庭成员、朋友、支付人电话转原值
          if (familyMemsPhonesTemp.length > 0) {
            for (let i = 0; i < familyMemsPhonesTemp.length; i++) {
              familyMems[i].phone = familyMemsPhonesTemp[i];
            }
          }
          if (japanRelativesPhonesTemp.length > 0) {
            for (let i = 0; i < japanRelativesPhonesTemp.length; i++) {
              japanRelatives[i].phone = japanRelativesPhonesTemp[i];
            }
          }
          if (fundingPayerPhonesTemp.length > 0) {
            for (let i = 0; i < fundingPayerPhonesTemp.length; i++) {
              fundingPayer[i].phone = fundingPayerPhonesTemp[i];
            }
          }
        });
      }, 1000);
    },
    // 导出excel
    exportExcel: function () {
      let crmid = this.$route.params.crm_id;
      let msid = this.$route.query.msid;
      let url = `/interview/Form/exportExcel/crm_id/${crmid}/msid/${msid}`;
      let filename = `${this.getReportName()}.xlsx`;
      this.$http.downloadFile({
        url: url,
        filename: filename,
      });
    },
    /**
     * 锁定报名报
     */
    async lockSignupTable() {
      let id = this.$route.query.msid;
      let isLocked = this.$route.query.is_locked;
      if (isLocked === '0') {
        try {
          await this.$http._post({
            url: '/interview/plan/lockSignupTable',
            data: { id }
          });
          this.refresh = true;
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 跳转编辑页
    openEdit: function() {
      this.$http._post({
        url: '/interview/Form/editSigUrl',
        data: { crm_id: this.crm_id }
      }).then(({ data }) => {
        window.open(data);
      });
    },
    getReportName: function() {
      let username = this.pageData.name ? this.pageData.name : '';
      let schoolname = (this.pageData.school_info && this.pageData.school_info.school_name) ? this.pageData.school_info.school_name : '';
      let year = this.pageData.custom_year ? `${this.pageData.custom_year}年` : '无';
      let month = this.pageData.custom_month ? `${this.pageData.custom_month}月` : '';
      return `${username}-${schoolname}-面试调查表-开学期：${year}${month}`;
    }
  },
  mounted() {
    this.crm_id = this.$route.params.crm_id;
    this.getPageData(this.$route.params.crm_id);
  }
};
</script>

<style scoped>
  .interview-table-wrap{
    padding-top: 30px;
    text-align: center;
  }
  .makeimg-wrap{
    display: inline-block;
  }
  .ms-table{
    margin: auto;
    border: 1px solid #ccc;
    pointer-events: none;
  }
  .ms-table td{
    text-align: center;
    min-width: 80px;
    height: 30px;
    line-height: 30px;
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
  }
  .ms-table td table td{
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
  }
  .ms-table td table td table td, .special-table, .special-table2 td{
    border: none !important;
  }
  .bg-code{
    background: #ccffb3
  }
  .isxiuman .bg-code{
    background: #c5d8ff;
  }
  .logo-img{
    display: none;
    margin-bottom: 20px;
  }
  .isxiuman .logo-img{
    display: block;
    max-width: 260px;
    margin: 0 auto 20px;
  }
  .fz16{
    font-size: 16px;
    height: 34px !important;
  }
  .fz20{
    font-size: 20px;
    height: 40px !important
  }
  .w30{
    width: 30px !important;
    min-width: 30px !important;
    max-width: 30px !important;
  }
  .w50{
    width: 50px !important;
    min-width: 50px !important;
    max-width: 50px !important;
  }
  .w60{
    width: 60px !important;
    min-width: 60px !important;
    max-width: 60px !important;
  }
  .bordernone{
    border: none !important;
  }
  input[type='text']{
    display: inline-block;
    width: 100%;
    height: 100%;
    background: none;
    border: none;
    outline: none;
    padding: 0 10px;
    line-height: 30px;
    box-sizing: border-box
  }
  input[type='date']{
    border: none;
    background: none;
    width: 90%;
    margin: auto;
    outline: none;
    cursor: pointer;
    line-height:30px;
  }
  select{
    width: 90%;
    margin: auto;
    border: none;
    outline: none;
    height: 100%;
    cursor: pointer;
    line-height:30px;
  }
  textarea{
    display: block;
    width: 90%;
    background: none;
    border: none;
    resize: none;
    font-size: 14px;
    padding: 10px;
    outline: none
  }
  .btn-wrap{
    padding: 20px 0 50px;
    text-align: center;
  }
</style>
